import React from 'react';
import Plot from 'react-plotly.js';
import raw_data from './A.json';

export default class ScatterPlot extends React.Component{
    constructor(props) {
        super(props);
        this.state = { data: [], layout: {}, frames: [], config: {},country:'United States',selectedData:'', plot: '' };
        this.clean_data =[];
    }

    componentDidMount(){
        this.setState({selectedData:this.props.selectedData,
        country:this.props.country})
        this.update()    //this.update()
    };

    componentWillReceiveProps(props){
        this.setState({selectedData:props.selectedData,
        country:this.props.country})
        this.update()
        console.log(this.clean_data)
    }

    update(){
        var xx=[]
        let yy =[]

        var arrayLength = raw_data.length;
        for (var i = 0; i < arrayLength; i++) {
            if(raw_data[i]['country'] === this.props.country){
                xx.push(raw_data[i]['year'])
                yy.push(raw_data[i][this.props.selectedData])
            }
        }
        this.clean_data.push({
            x: xx,
            y: yy,
            type: 'scatter',
            mode: 'markers',
            marker: {color: 'green'},
        })
        this.setState({data:this.clean_data})
        console.log('clean data', this.clean_data)
        let plot = <Plot
        data={this.clean_data}
        layout={{width: 800, height: 300, title: this.props.selectedData}}
        />
        this.setState({plot});
        console.log('plot data', this.props.selectedData)
    }

    render(){
        return (
            <div>
                {this.state.plot}
            {/* <Plot
            data={this.state.data}
            layout={{width: 800, height: 300, title: this.props.selectedData}}
            /> */}
            </div>
        );}

}